function finiteNumber(value, fallback = 0) {
  const number = Number(value)
  return Number.isFinite(number) ? number : fallback
}

/**
 * Convert the backend cashback level boundaries into a progress percentage.
 * The backend supplies the current tier's [from, to] range; a max-level
 * profile has no next-level amount and an empty range.
 */
export function cashbackProgressPercent(data) {
  if (!data) return 0

  const turnover = Math.max(0, finiteNumber(data.turnover))
  const from = Math.max(0, finiteNumber(data.level_from_rub))
  const to = Math.max(0, finiteNumber(data.level_to_rub))
  const nextLevelRub = Math.max(0, finiteNumber(data.next_level_rub))

  if (nextLevelRub <= 0 || to <= from) return 100

  const span = to - from
  const current = Math.max(0, Math.min(span, turnover - from))
  return Math.max(0, Math.min(100, (current / span) * 100))
}

export function cashbackLevelName(data) {
  const name = String(data?.level_name ?? '').trim()
  return name || 'Новичок'
}
